import { sortBasesChronologically } from './current-base.js';
import { mapsSearchUrl } from './maps-url.js';

/** Alloggi dell'istanza (non dal template Piano), ordinati per data di inizio. */
export function resolveTripBases(live) {
  return sortBasesChronologically(live?.bases ?? []);
}

/** URL Google Maps per un alloggio (link salvato o ricerca per nome). */
export function resolveBaseMapsUrl(base) {
  if (!base) return null;
  if (base.mapsUrl) return base.mapsUrl;
  const query = [base.name, base.subtitle].filter(Boolean).join(' ');
  return mapsSearchUrl(query);
}
